import { useRef, useEffect } from "preact/hooks";
import assets, { getDay } from "../assets";
import GRID from "../components/GRID";
import { achievement } from "../utils";
import { BackToAtrium } from "./breakouts";

export default {
    background: assets.keynotes.df,
    links: [{
        ...BackToAtrium,
        top: "91.7%",
        left: "43.9%"
    }],
    extras: assets.keynotes.GRID.map(it => <GRID {...it}
        modalContent={(link, row) => () => {
            const day = getDay()
            const ref = useRef(null)
            const triggered = useRef(false)

            useEffect(() => {
                const player = new Vimeo.Player(ref.current)

                player.on("timeupdate", it => {

                    if (day === 0 || day < row + 1) return;
                    if (it.percent <= .95 || triggered.current) return;
                    achievement(link[2])
                    triggered.current = true
                })
            }, [])

            return <iframe ref={ref} src={link[1]} allow="autoplay" style={{
                border: 0,
                borderRadius: "16px",
                width: "66em",
                marginTop: "22px",
                aspectRatio: "16/9"
            }} />
        }}
    />),
    showNavbar: false,
    name: "keynotes"
}